import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"];
  static values = {
    price: Number,
    discount: Number,
  }

  connect(){
    this.price = this.priceValue || 0;
    this.discount = this.discountValue || 0;

    const result = Math.round((this.price - this.discount) / this.price * 100);

    if(this.discount >= 0 && !isNaN(result)) {
      this.containerTarget.classList.remove("hidden");  
    } 

    this.prevDiscount = `${result}%`;
    this.containerTarget.innerText = this.containerTarget.innerText + this.prevDiscount;
  }

  updatePriceValue(e){
    this.price = Number(e.target.value);

    this.#updateContainerValue();
  }

  updateDiscountValue(e){
    this.discount = Number(e.target.value);

    this.#updateContainerValue();
  }

  #updateContainerValue(){
    const result = ((this.price - this.discount) / this.price * 100).toFixed(2);

    if(result >= 0 && result < 100 && !isNaN(result)) {
      this.containerTarget.classList.remove("hidden");
      const currentDiscount = `${result}%`;
      this.containerTarget.innerText = this.containerTarget.innerText.replace(this.prevDiscount, currentDiscount);
      this.prevDiscount = currentDiscount;
    } else {
      this.containerTarget.classList.add("hidden");
    }
  }
}
